export default "__VITE_ASSET__Culp7Z2x__"